<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/11-IP-boost-your-confidence-before-the-interview.svg"
                class="img-fluid"
                alt="Boost your confidence before the interview"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey p-3">
      <p>Job interviews can be stressful, especially if you haven’t had many before. What can really help calm your nerves and boost your confidence is to <strong>prepare</strong> and <strong>practice</strong> before the interview.</p>
    </content-block>
    <content-block>
      <div class="row">
        <div class="col-md-8 p-4">
          <h2 class="content-block__header">Prepare</h2>
          <ul>
            <li>Familiarize yourself with the department and its role in the College</li>
            <li>Try to find out who you’ll be interviewing with and look them up online (LinkedIn, Google)</li>
            <li>Think about your interest in the department and what you want to learn</li>
            <li>Jot down questions you want to ask during the interview</li>
            <li>Review the job posting, and identify how your skills match the job requirements</li>
            <li>Anticipate interview questions (here are some <a
              :href="`${publicPath}docs/Tip sheets and other materials/6-Sample Interview Questions.pdf`"
              target="_blank"
            >common interview questions</a> they might ask you)</li>
          </ul>
        </div>
        <div class="col-md bg-img bg-img--interview-prep-01-1">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
      </div>
    </content-block>
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--interview-prep-01-2">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-8 p-4">
         <h2 class="content-block__header">Practice</h2>
          <ul>
            <li>Prepare a <a href="https://www.youtube.com/watch?v=MmFuWmzeiDs" target="_blank">brief self-introduction</a> that summarizes your education, skills and relevant experience </li>
            <li>Practice answering the questions you anticipate them asking </li>
            <li>Ensure your answers are no more than 2 minutes long</li>
            <li>Prepare and practice according to the type of interview (for phone and virtual, consider equipment, having a quiet space, lighting; for in-person, consider the dress code)</li>
            <li>Book a virtual interview practice appointment with Career Services or use the virtual practice tool Big Interview via <a href="https://hire.centennialcollege.ca/home.htm" target="_blank">HireCentennial</a></li>
          </ul>
        </div>
      </div>
    </content-block>
    <content-block class="p-4">
      <p>When you’re trying to anticipate the kinds of questions you might be asked in the interview, keep in mind that many of these will be <strong>behavioural questions</strong>, that is, questions based on how you acted in a specific situation. The <a href="https://www.youtube.com/watch?v=mH3DaeJSwy4&amp;t=163s" target="_blank">STAR method</a> can help you respond to behavioural interview questions so that you hit the points the interviewer is looking for while keeping your response succinct and easy to follow.</p>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
